module.exports = __webpack_public_path__ + "static/fonts/DINMittelschriftStd.a4220bc.eot";